var e = e || {};
//var ga = {};
( function () {
    'use strict';
    jQuery( document ).ready( function () {
        // Append all modals to body for right z-index
        jQuery( '.modal' ).appendTo( 'body' );
        // Make modal work inside dropdown menu
        jQuery( '.dropdown-menu' ).on( 'click', '[data-toggle=modal]', function ( e ) {
            e.stopPropagation();
            jQuery( jQuery( e.target ).data( 'target' ) ).modal();
        } );
        // Deactive pointer event on scroll
        jQuery( '.mega' ).click( function () {
            jQuery( '.mega iframe' ).css( 'pointer-events', 'auto' );
        } );
        jQuery( '.mega' ).mouseleave( function () {
            jQuery( '.mega iframe' ).css( 'pointer-events', 'none' );
        } );
        // Change iframe url on mouseOver and click
        jQuery( 'a.hereford-dinner-booking' ).on( 'click', function () {
            var src = jQuery( this ).data( 'src' );
            jQuery( 'div.modal.dinnerbooking iframe' ).attr('src', src);
            jQuery( '#hereford-dinner-booking iframe' ).attr('src', src);
            jQuery( '#hereford-dinner-booking iframe' ).addClass('ga-cid');
        } );
        // Add class to iframe to catch it with GA
        jQuery( 'div.modal.dinnerbooking iframe' ).addClass('ga-cid');
        // Trigger newsletterpopup on click
        jQuery( document ).on( 'click', 'a.newsletter-popup', function () {
            jQuery( '.js-e-newsletter-popup-teaser a' ).trigger( 'click' );
        } );
        // Checkbox list inside dropdown
        var options = [];
        jQuery( '.dropup a' ).on( 'click', function ( event ) {
            var $target = $( event.currentTarget ),
                val = $target.attr( 'data-value' ),
                $inp = $target.find( 'input' ),
                idx;
            if ( ( idx = options.indexOf( val ) ) > -1 ) {
                options.splice( idx, 1 );
                setTimeout( function () {
                    $inp.prop( 'checked', false );
                }, 0 );
            }
            else {
                options.push( val );
                setTimeout( function () {
                    $inp.prop( 'checked', true );
                }, 0 );
            }
            jQuery( event.target ).blur();
            console.log( options );
            return false;
        } );
        // Google Analytics tracking
        jQuery( '.hereford-modal-menu' ).find( 'a' ).on( 'click', function () {
            //var jResturant = jQuery.trim( jQuery( this ).text() );
            //ga( 'send', 'event', 'Restaurantvælger', jResturant );
        } );
    } );
}() );
